<template>
  <div class="header3">
    <div class="main-container">
      <!-- hd-top -->
      <div class="hd-top fix">
        <div class="logo">
          <a href="index.html">
            <img src="static/images/f1-tit03.png" alt="首页" style="pointer-events: none;"/>
          </a>
        </div>
        <span @click="openNav" :class="['menuBtn',{'open': isOpen}]"></span>
        <!-- hd-rightBtn -->
        <div v-if="!logined" class="hd-rightBtn">
          <a href="javascript:void(0)" class="login" @click="login()">登录</a>
          <a>/</a>
          <a href="regist.html" class="sign">注册</a>
        </div>
        <div v-if="logined" class="hd-rightBtnNo">
          <a href="personal.html" :title="userName" class="username" target="_blank">{{userName}}</a>
          <a href="javascript:void(0)" @click="logout('self_exit')">退出</a>
        </div>
        <!-- hd-rightBtn end -->
        <!-- nav -->
        <div :class="['nav',{'open': isOpen}]">
          <ul class="ul-nav fix">
            <li :class="{'on': tab === 1}">
              <a href="index.html" class="v1">首页</a>
            </li>
            <li :class="{'on': tab === 2}" v-if="hasPriv('casewrite')">
              <a @click="tabHandler(2)" href="javascript:;" class="v1 case">案例编写</a>
            </li>
            <li :class="{'on': tab === 3}" v-if="hasPriv('caseexamine')">
              <a @click="tabHandler(3)" href="javascript:;" class="v1 case">案例审核</a>
            </li>
            <li :class="{'on': tab === 5}" v-if="hasPriv('casetask')">
              <a @click="tabHandler(5)" href="javascript:;" class="v1 case">审核任务分配</a>
            </li>
            <li :class="{'on': tab === 4}" v-if="hasPriv('casestat')">
              <a @click="tabHandler(4)" href="javascript:;" class="v1 case">案例统计</a>
            </li>
          </ul>
        </div>
        <!-- nav end -->
      </div>
      <!-- hd-top end -->
    </div>
     <ie-tips />
  </div>
  <!-- 头部 end -->
</template>

<script>
import ieTips from "../components/ieTips.vue"
import priv from '../../utils/priv.js'
import axios from 'axios'
export default {
  props: {
    // 设置免登录访问， true 为免登录
    noLogin: {
      type: Boolean,
      default: false
    },
    tab: {
      type: Number,
      default: 1
    }
  },
  name: 'mHeader',
  data: () => {
    return {
      custom: {},
      isOpen: false,
      messageCount: 0,
      q: '',
      message: '',
      messageShow: false,
      logined: false,
      userName: '',
    }
  },
  watch: {
    searchKey(a, o) {
      this.q = this.searchKey ? this.searchKey : ''
    }
  },
  async created() {
    this.isLogin()
    let result = await priv.checkButtonPriv()
    this.custom = Object.assign({}, result)
  },
  components: {
    ieTips
  },
  methods: {
    hasPriv(k) {
      if (this.custom.keys) {
        return this.custom.keys[k] === 1
      }
      return false
    },
    async isOnline(logined) {
      let referer = localStorage.getItem('Referer')
        ? localStorage.getItem('Referer')
        : location.href
      let configs = await this.axios.get('/front/member/login/config?Referer=' + encodeURIComponent(referer)).then(res => res.data.data)
      let zasServerUrl = configs ? configs.zasServerUrl : ''
      let zasClientId = configs ? configs.clientID : ''
      let data = {
        Validate: getInfo(),
        client_id: zasClientId
      }
      axios.post(zasServerUrl + 'zapiv3/browser/login/onlineValidata?' + new Date(), data, { withCredentials: true }).then(res => {
        res = res.data
        if (res.success) {
          if (!logined) {
            localStorage.setItem('Referer', location.href)
            window.location.href = './login.html'
          }
        } else {
          if (logined) {
            this.logout('self_exit')
          } else { 
            localStorage.setItem('Referer', location.href)
            window.location.href = './login.html'
          }
        }
      })
    },
    async isLogin() {
      let resp = await this.axios
        .get('/front/member/login/username')
        .then(resp => resp.data)
      if (resp.status === 1) {
        this.logined = true
        this.userName = resp.data.username
        let result = await priv.checkCaseAudit()
        this.$emit('getLoginResult', result, resp.data)
        if (!resp.data.backgroundLogin){
          this.isOnline(true)
        } 
      } else {
        if (!this.noLogin) {
          // window.location.href = './login.html'
          this.isOnline(false)
        }
      }
    },
    async tabHandler(val) {
      let _this = this
      if (2 === val) {
        if (_this.custom.casewrite.msg) {
          util.showInfoMessage(_this.custom.casewrite.msg)
          if (_this.custom.casewrite.redirecturl) {
            setTimeout(function() {
              location.href = _this.custom.casewrite.redirecturl
            }, _this.custom.casewrite.timeout)
          }
        } else {
          window.location.href ='./case.html'
        }
        // this.$confirm('编写案例的注意事项', '编写案例需知', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(async () => {

        // }).catch(() => {})
      }
      if (3 === val) {
        let result = await priv.checkCaseAudit()
        if (result === 2 || result === 3 || result === 5 || result === 6) {
          window.location.href = './caseAudit.html'
        } else {
          return
        }
      }
      if (4 === val) {
        window.location.href = './caseTab.html'
      }
      if (5 === val) {
        window.location.href = './assignCase.html'
      }
    },
    openNav() {
      this.isOpen = !this.isOpen
    },
    login() {
      localStorage.setItem('Referer', location.href)
      window.location.href = 'login.html'
    },
    async logout(action) {
      let referer = localStorage.getItem('Referer') ? localStorage.getItem('Referer') : location.href
      let configs = await this.axios
      .get(
        '/front/member/login/config?Referer=' + encodeURIComponent(referer)
      )
      .then(res => res.data.data)
      let zasClientId = configs ? configs.clientID : ''
      let zasServerUrl = configs ? configs.zasServerUrl : ''
      let data = {
        Validate: getInfo(),
        client_id: zasClientId
      }
      axios.post(zasServerUrl + 'zapiv3/browser/login/logout?' + new Date().getTime(), data, { withCredentials: true }).then(res => {
        this.reload(referer, action)
      })
    },
    async reload(referer, action){
      let configs = await this.axios
        .get('/front/member/logout?Referer=' + encodeURIComponent(referer) + '&action=' + action)
        .then(res => res.data.data)
        if ('self_exit' === action){
          let zasLogout = configs ? configs.ssologout : ''
          // window.location.href = zasLogout
          window.location.href = 'index.html'
        }
    },
    async initMessageCount() {
      let resp = await this.axios.get(`/front/message/count`).then(resp => resp)
      if (resp && resp.data) {
        this.messageCount = resp.data.data
      }
    },
    getMsg(data) {
      this.messageShow = data
    }
  }
}
</script>
<style scoped>
.header2 {
  position: relative;
  margin: 0 auto;
  width: 100%;
  background: #4372d1 url(../../../static/images/header3.png) no-repeat;
}
.ul-nav {
  margin-bottom: 0;
}
a:hover {
  color: #ffffff;
  text-decoration: none;
}
.hd-top {
  padding-top: 20px;
  margin-bottom: 0;
}
.logo {
  width: 358px;
  display: flex;
  align-items: center;

  float: left;
}
.nav {
  float: right;
  margin-left: 30px;
}
.ul-nav li {
  margin-left: 0px;
  float: left;
}
.ul-nav li a {
  color: #fff;
}
.logo img {
  height: auto;
  width: 100%;
}
.case {
  background: #1ad5b1 !important;
  margin-right: 10px;
  padding: 0 7px;
  /* margin-right:50px */
}
@media only screen and (max-width: 767px) {
  .logo {
    width: 168px;
  }
  .logo img {
    height: 20px;
    width: auto;
  }
}
@media only screen and (max-width: 768px) {
  .logo img {
    width: auto;
  }
}
@media only screen and (max-width: 321px) {
  .hd-rightBtnNo .username {
    width: 60px;
    margin-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/mHeader3.vue